import {Injectable, OnInit} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {MessageService} from './message.service';
import {Room} from '../models/room.model';
import { Floor } from '../models/floor.model';
import {RoomType} from '../models/roomType.model';
import { Indicator } from '../models/indicator.model';
import { EMPTY, Observable } from 'rxjs';
import { RoomCalendar } from '../models/room-calendar.model';

export interface DayRoomRequest {
  room: string;
  day: string; // Must be DD-MM-YYYY
  dayRoomStatus: 'CLOSED' | 'OUT_OF_ORDER' | 'OUT_OF_SERVICE' | 'AVAILABLE';
  goupId: number;
}

@Injectable({
  providedIn: 'root'
})
export class RoomService implements OnInit{

  

  url:string ="https://beds-api.fractalite.com/properties/";
  api:string = environment.api; 
  

  private urlRoom:string=  environment.api+ '/rooms/findRoomsRoomType'; 
  private getRoom:string=environment.api+ '/rooms'
  private apiRoot = environment.crmTest;
  public accessToken:any;
  public refreshToken:any;
  public userProfil:any;

  // private roomTypes = "https://beds-api.fractalite.com/properties/2/units";
  corsHeaders;
  constructor(private readonly keycloak: KeycloakService,
              private messageService: MessageService,
              private http: HttpClient) { }

  async ngOnInit(): Promise<void> {
    this.refreshToken = this.keycloak.getKeycloakInstance().refreshToken;
    this.accessToken = await this.keycloak.getToken();
    this.userProfil = await this.keycloak.loadUserProfile();

    //console.log('Refresh token : '+ this.refreshToken);
    //console.log('Access Token : '+ this.accessToken);
    //console.log('User Informations : '+this.userProfil);

    this.corsHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:4200'
    });
    
  }
   getRoomTypesFromBeds(){
    let token = 'Bearer ' + this.keycloak.getKeycloakInstance().token;
    return this.http.get(this.url+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+'/units',{headers: new HttpHeaders({
      'Authorization': token
    })});
   }
  sendParametres(){
    const body = {
      //'refresh-token': this.refreshToken,
      'access-token': this.accessToken,
      'url': this.url+JSON.parse(localStorage.getItem("userDetails")).group.attributes[0].value+'/units',
    };
    console.log(body)
  
    return this.http.post<any>(this.api+'/settings/new',body);
  }
  postRoomType(roomtype:any){
    let url = this.api + "/roomtypes"
   return this.http.post(url,roomtype)
  }
  getRooms(page:number,size:number){
    return this.http.get(this.api+'/rooms/getAll?pageNo='+page+'&pageSize='+size);
  }

  getAllRooms()
  {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    if (!userDetails || !userDetails.group) { return EMPTY; }
    return this.http.get(this.api+'/rooms/findAll'+'?&group='+userDetails.group.groupId);
  }
  getAllRoomsSize()
  {
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    if (!userDetails || !userDetails.group) { return EMPTY; }
    return this.http.get(this.api+'/rooms/findAll/size'+'?&group='+userDetails.group.groupId);
  }

  getRoomsByRoomTypeId(id:number){
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || 'null');
    if (!userDetails || !userDetails.group) { return EMPTY; }
    return this.http.get(this.api+'/checkins/rooms/' + id + '/CLEAN'+'?&group='+userDetails.group.groupId);
  }
  getAllRoomStatus(): Observable<any> {
    const today = new Date();
    
    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    
    const myApi = `http://pmsapi.fractalite.com/api/dayrooms?day=${formattedDate}`;
    
    return this.http.get(myApi);
  }
  getRoomsByRoomTypeCode(code:any){
    return this.http.get(this.urlRoom+'/'+code+'?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId);
  }
  getRoomsById(id:any) : Observable<any> {
    return this.http.get<any>(this.getRoom+'/'+id);
  }

  getAllRoomTypes(){
    console.log("refreshToken: ", this.refreshToken);
    console.log("accessToken: ", this.accessToken);
    console.log("userProfil: ", this.userProfil);
    console.log("token: ", this.keycloak.getKeycloakInstance().token);
    // console.log("token: ", this.token);
    let token = 'Bearer ' + this.keycloak.getKeycloakInstance().token;
    return this.http.get(this.api + "/roomtypes/findAll"+'?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId,{headers: new HttpHeaders({
      'Authorization': token
    })});
  }
  getAllRoomTypes2(){
    console.log("refreshToken: ", this.refreshToken);
    console.log("accessToken: ", this.accessToken);
    console.log("userProfil: ", this.userProfil);
    console.log("token: ", this.keycloak.getKeycloakInstance().token);
    // console.log("token: ", this.token);
    let token = 'Bearer ' + this.keycloak.getKeycloakInstance().token;
    return this.http.get(this.api + "/roomtypes/getAll"+'?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId,{headers: new HttpHeaders({
      'Authorization': token
    })});
  }

  getRoomTypeByName(name:string){
    return this.http.get(this.api+'/roomtypes/findByName/'+name+'?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId);
  }
  getRoomType(){
    return this.http.get(this.api+'/roomtypes/findAll'+'?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId);
  }

  generateQRCode(room:Room){
    return this.http.put(this.api+'/rooms/generateQR',room,this.corsHeaders);
  }

  updateRoom(room:Room){
    console.log("room Service",room,' : ',this.api+'/rooms')
    return this.http.put(this.api+'/rooms',room);
  }
  createRoom(room:Room){
    console.log(room);
    return this.http.post(this.api+'/rooms/',room);
  }
  getRoombyID(room:Room){
    console.log("room",room);
    return this.http.get(this.api+'/rooms/'+(room.id || room.roomId));
  }
  getRoombyIDA(roomId:any){
    return this.http.get(this.api+'/rooms/'+roomId);
  }
  deleteRoom(room:Room){
    return this.http.delete(this.api+'/rooms/'+(room.id || room.roomId));
  }

  deleteRoomType(roomType:RoomType){
    return this.http.delete(this.api+'/roomtypes/'+roomType.id)
  }

  getRoomsByFloor(floor:Floor){
    return this.http.get(this.api+'/rooms/findRoomsByFloor/'+floor.floorId);
  }

  getRoomsByRoomType(roomType:RoomType){
    return this.http.get(this.api+'/rooms/findRoomsRoomType/'+roomType.code);
  }

  localiseRoom(indicator:Indicator){
    return this.http.post(this.api + '/rooms/indicator',indicator)
  }

  getStatistics(){
    return this.http.get(this.api + '/rooms/stats')
  }

  getWeeklyStatistics(date : Date){
    return this.http.post(this.api+'/rooms/weeklyStats',date);
  }
  getTagsRoomView():Observable<any>{
    let urlTagsView = this.apiRoot + '/tags/RoomView';
    return this.http.get(urlTagsView);
  }
  getTagsRoomBedLayout():Observable<any>{
    let urlTagsBedLayout=  this.apiRoot + '/tags/RoomBedLayout';
    return this.http.get(urlTagsBedLayout);
  }
  getTagsRoomRoomOther():Observable<any>{
    let urlTagsOther= this.apiRoot + '/tags/RoomOther';
    return this.http.get(urlTagsOther);
  }

  getRoomCalendar(from: string, to: string): Observable<RoomCalendar[]> {
    let queryParams = new HttpParams()
      .set('group', JSON.parse(localStorage.getItem("userDetails")!).group.groupId)
      .set('from', from)
      .set('to', to);
  
    return this.http.get<RoomCalendar[]>(`${this.api}/reservations/room/calendar`, { params: queryParams });
  }

  getCheckinsToday(): Observable<any[]> {
    const today = new Date().toISOString().split('T')[0]; // Format YYYY-MM-DD
    const groupId = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    return this.http.get<any[]>(`${this.api}/checkins/fromDate?group=${groupId}&date=${today}`);
  }


  getAllRoomsVirtual(): Observable<any[]> {
    return this.http.get<any[]>(`${this.api}/rooms/findAll/virtual?group=${this.getGroupId()}`);
  }

  /**
   * Helper to format Date objects to DD-MM-YYYY as required by your backend
   */
  formatDateForBackend(date: Date): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}-${m}-${y}`;
  }

  /**
   * Updates a room status for a single day. 
   * Note: To avoid the START_ARRAY error, call this in a loop for date ranges.
   */
  // updateDayRoomStatus(payload: DayRoomRequest): Observable<any> {
  //   return this.http.post(`${this.api}/dayrooms`, payload);
  // }

  updateDayRoomStatus(payload: DayRoomRequest[]): Observable<HttpResponse<string>> {
    return this.http.post(`${this.api}/dayrooms`, payload, {
      observe: 'response', // Tells Angular to return the full response object, including the status code
      responseType: 'text' as const // 'as const' forces TypeScript to use the correct overload to prevent JSON parsing
    });
  }

  /**
   * Helper to retrieve Group ID from local storage
   */
  private getGroupId(): number {
    const userDetails = localStorage.getItem("userDetails");
    return userDetails ? JSON.parse(userDetails).group.groupId : 0;
  }

  getUnavailableRooms(fromDate: string, toDate: string): Observable<any[]> {
    const groupId = this.getGroupId();
    return this.http.get<any[]>(`${this.api}/dayrooms/range/${groupId}?start=${fromDate}&end=${toDate}&statuses=CLOSED&statuses=OUT_OF_SERVICE&statuses=OUT_OF_ORDER`);
  }
  
  // getAllBuildings(groupId: number ): Observable<any[]> {
  //   return this.http.get<any[]>(`${this.api}/buildings/findAll?&group=${groupId}`);
  // }

  // On utilise getGroupId() si aucun groupId n'est passé en paramètre
getAllBuildings(groupId: number = this.getGroupId()): Observable<any[]> {
  return this.http.get<any[]>(`${this.api}/buildings/findAll?&group=${groupId}`);
}
  // https://pmsvaleriaapi.fractalstay.com/api/buildings/findAll?&group=1
}
